export default __webpack_public_path__ + "static/media/addItem.7fe73c8d.svg";